/***
 * Created on 2023/11/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import CreateAccountNoticeDialog from "./create_account_notice_dialog";
import SocialSignupDialog from "./social_signup_dialog";
import GdprDialog from "../../signup/gdpr_dialog";

function CreateAccountDialog({isShowNotice=true, showModal, closeModal, socialAccount, metadata, action}) {
    const [showState, setShowState] = useState(isShowNotice ? 'notice' : 'gdpr');

    return (
        <>
            {showState === 'notice' && <CreateAccountNoticeDialog showModal={showState === 'notice'} closeModal={closeModal} dispatch={setShowState}/>}
            {showState === 'gdpr' && <GdprDialog showModal={showState === 'gdpr'} closeModal={closeModal} submitAction={() => setShowState('create')}/>}
            {showState === 'create' && <SocialSignupDialog showModal={showState === 'create'} closeModal={closeModal} action={action} socialAccount={socialAccount} metadata={metadata}/>}
        </>

    );
}

export default CreateAccountDialog;